// @ts-nocheck
import styled from 'styled-components';

export const FootfallAttributionMapSelectorsStyled = styled.div`
  padding: 16px;
  background-color: ${props => props.theme.uiColors.background01};
  .singleSelectorComponent__menu {
    z-index: 10;
  }
  .footfallAttributionMapSelectors {
    &__selectorsSection {
      align-items: center;
      display: flex;
      flex-direction: row;
      gap: 16px;
      width: 50%;
      &--expanded {
        width: 100%;
      }
    }
    &__dimensionSelector, &__metricSelector {
      flex: 1;
      .selectorLabel {
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeM};
        line-height: 19px;
        margin-right: 8px;
        margin-bottom: 0;
      }
    }
  }
`;
